/* @flow */
import AuthenticationView from 'auth/components/AuthenticationView';
import TextAppLink from 'user/components/TextAppLink';
import * as React from 'react';

class TextAppLinkPage extends React.Component<$FlowFixMeProps> {
  render() {
    return (
      <AuthenticationView {...this.props} size="large" className="TextAppLinkPage">
        <TextAppLink />
      </AuthenticationView>
    );
  }
}

export default TextAppLinkPage;
